import {
  ArrowLeftOutlined,
  GiftOutlined,
  SaveOutlined,
  TableOutlined,
} from "@ant-design/icons";
import { Button, Row, Space, Tooltip, Typography } from "antd";
import PropTypes from "prop-types";

import { useCustomToolStore } from "../../store/custom-tool-store";
import { ShareBtn } from "./ShareBtn";
import useSimplePromptStudio from "../hooks/useSimplePromptStudio";
import { UPLOAD } from "./constants";

function Layout({ children }) {
  const { details } = useCustomToolStore();
  const { handleSpsNavigate } = useSimplePromptStudio();

  return (
    <div className="flex-dir-col">
      <Row align="middle" className="sps-top-bar">
        <div>
          <Space>
            <Button
              size="small"
              type="text"
              onClick={() => handleSpsNavigate(UPLOAD)}
            >
              <ArrowLeftOutlined />
            </Button>
            <Typography.Text strong ellipsis>
              {details?.tool_name}
            </Typography.Text>
          </Space>
        </div>
        <div>
          <Space size={12}>
            <Tooltip title="Coming soon!">
              <Button icon={<GiftOutlined />}>Create App</Button>
            </Tooltip>
            <Tooltip title="Coming soon!">
              <Button icon={<TableOutlined />}>Download Excel</Button>
            </Tooltip>
            <div className="sps-v-divider" />
            <ShareBtn />
            <Tooltip title="Coming soon!">
              <Button icon={<SaveOutlined />} type="primary" />
            </Tooltip>
          </Space>
        </div>
      </Row>
      <div className="flex-1 overflow-hidden">{children}</div>
    </div>
  );
}

Layout.propTypes = {
  children: PropTypes.object.isRequired,
};

export { Layout };
